import request from "../utils/request";//引入request.js
export function getNavColumn() {
    return request({url: '/querycolumn', method: 'get'})
}

export function getShowColumn(data) {
    return request({url: '/queryshowcolumn', method: 'post',data:data})
}

export function getSwiper(data){
    return request({url: '/swiperlist', method: 'post',data:data})
}

export function getNewsDetail(data) {
    return request({url: '/newsdetail', method: 'post', data: data})
}

export function getSubColumn(data) {
    return request({url: '/querysubcolumn', method: 'post', data: data})
}
export function getNewsByColumn(data) {
    return request({url: '/getnewsbycolumn', method: 'post', data: data})
}
export function getColumnById(data) {
    return request({url: '/getcolumnbyid', method: 'post', data: data})
}
export function searchNews(data){
    return request({url: '/searchnews', method: 'post', data: data})
}

export function getNewsBySubColumn(data){
    return request({url: '/getnewsbysubcolumn', method: 'post', data: data})
}

export function addBrowseCnt(data){
    return request({url: '/addbrowsecnt', method: 'post', data: data})
}

export function getNewsByListQuery(data){
    return request({url: '/querynews', method: 'post', data: data})
}
export function getHtml(data){
    return request({url:'/gethtmlctx',method: 'post', data:data})
}
